import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Spinner } from 'reactstrap';
import { buildAxiosConfig } from './functions/apiConfig';
import { useAuth0 } from "@auth0/auth0-react";

export default function Pdf(props) {
    const [PDFUrl, setPDFUrl] = useState(null);
    const [PDFBlob, setPDFBlob] = useState(null);
    const { getIdTokenClaims } = useAuth0();   // B4: per-user Auth0 ID token for /cfcs identity binding

    const documentId = props.documentId
    const userId = props.userId
    const documentSigned = props.documentSigned
    const createPDFUrl = `${process.env.REACT_APP_WWWROOT}/CFCs/PDF/AjaxRequestHandler.cfc?method=createPDF&document_id=${documentId}&user_id=${userId}&documentSigned=${documentSigned}`
    
    useEffect(async () => {
        setPDFUrl(null)
        setPDFBlob(null)
        
        try {
            // B4: attach the caller's Auth0 ID token so the backend can bind email == user_id
            // (createPDF only; the /EFS blob fetch below stays token-free — /EFS is public static)
            const idClaims = await getIdTokenClaims();
            const result = await axios(createPDFUrl, buildAxiosConfig({ headers: { 'X-Id-Token': idClaims?.__raw } }));
            //console.log('Pdf,result', result)
            const data = result.data.data[0]
            //console.log('Pdf,data', data)
        
            const pdfPath = `${process.env.REACT_APP_WWWROOT}${data.internal_pdf_path}${data.filename}?${Date.now()}`;

            const pdfResponse = await axios.get(pdfPath, buildAxiosConfig({ responseType: 'blob' }));
            const blob = new Blob([pdfResponse.data], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            setPDFBlob(blobUrl);
            setPDFUrl(pdfPath); // Keep for reference if needed
        } catch (error) {
            console.error('Error loading PDF:', error);
            console.error('Error details:', error.response?.status, error.response?.statusText);
        }
      }, [createPDFUrl]);

    // Cleanup blob URL on unmount
    useEffect(() => {
        return () => {
            if (PDFBlob) {
                URL.revokeObjectURL(PDFBlob);
            }
        };
    }, [PDFBlob]);

    return (
        <>
        {PDFBlob ? <div className="embed-responsive embed-responsive-16by9" style={{height: '100vh'}}>
            <embed className="embed-responsive-item" src={PDFBlob}
            style={{width: '100%', height: '100%', display: 'block'}} allowFullScreen></embed> 
        </div>
        :
        <Spinner color="dark" />
        }
        </>
    );
}
